import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { replace } from "redux-first-history";
import ym from "react-yandex-metrika";

export enum TutorialPages {
  AllTutorials,
  TutorialArticles,
  TutorialVideos,
}

export interface TutorialStore {
  page: TutorialPages;
  history: TutorialPages[];
}

export const InitialTutorialsState: TutorialStore = {
  page: TutorialPages.AllTutorials,
  history: [TutorialPages.AllTutorials],
};

const TutorialsSlice = createSlice({
  name: "TutorialsSlice",
  initialState: InitialTutorialsState,
  reducers: {
    setPageWithoutRouting(state, action: PayloadAction<TutorialPages>) {
      state.page = action.payload;
    },
    setHistory(state, action: PayloadAction<TutorialPages[]>) {
      state.history = action.payload;
    },
    pushToHistory(state, action: PayloadAction<TutorialPages>) {
      state.history.push(action.payload);
    },
    goBack(state) {
      if (state.history.length > 1) {
        state.page = state.history[state.history.length - 2];
        state.history.pop();
      }
    },
  },
});

const TutorialPagesUrls = {
  [TutorialPages.AllTutorials]: "/tutorials",
  [TutorialPages.TutorialArticles]: "/tutorialArticles",
  [TutorialPages.TutorialVideos]: "/tutorialVideos",
};

const setPage = (page: TutorialPages) => {
  return (dispatch: any) => {
    const newUrl =
      TutorialPagesUrls[TutorialPages.AllTutorials] + TutorialPagesUrls[page];
    ym("hit", newUrl);

    dispatch(TutorialsActions.setPageWithoutRouting(page));
    dispatch(TutorialsActions.pushToHistory(page));
    dispatch(replace(newUrl));
  };
};

export const changeBreadcrumb = (history: TutorialPages[]) => {
  return (dispatch: any) => {
    const page = history[history.length - 1];
    const newUrl = TutorialPagesUrls[page];
    ym("hit", newUrl);
    dispatch(TutorialsActions.setPageWithoutRouting(page));
    dispatch(TutorialsActions.goBack());
    dispatch(replace(newUrl));
  };
};

export const TutorialsActions = {
  ...TutorialsSlice.actions,
  setPage,
  changeBreadcrumb,
};
export const TutorialsReducer = TutorialsSlice.reducer;
